import { render, staticRenderFns } from "./HeaderMenu.vue?vue&type=template&id=b5f9336a"
import script from "./HeaderMenu.vue?vue&type=script&lang=js"
export * from "./HeaderMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports